<template>
  <div class="search_box">
    <Header @search="onSearch" />
    <Tab />
    <div class="search">
      <div class="search_header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">{{
            $t('首页')
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/home' }">{{
            $t('新闻中心')
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('搜索结果页') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search_content">
        <p>
          <keep-alive>
            <el-input v-model="input" :placeholder="$t('搜索')"></el-input>
          </keep-alive>
          <el-button
            @click="btnSearch"
            :clstag="`newscenter|keycount|search-pc|click-btnSearch`"
            type="primary"
            >{{ $t('搜索') }}</el-button
          >
        </p>
        <div class="s_bitor">
          <p>{{ $t('共') }} {{ searchData.length }}{{ $t('条结果') }}</p>
          <ul class="bitorItem">
            <li
              v-for="(item, index) in searchData"
              :key="index"
              @click="searchDetail(item)"
            >
              <strong>{{ index + 1 }}</strong>
              <p v-html="item.title"></p>
              <span>{{ item.createTime | formatDate }}</span>
            </li>
          </ul>
          <div class="pages">
            <p @click="subCurrent">&lt;&lt;</p>
            <el-pagination
              background
              @current-change="changeCurrent"
              layout="prev, pager, next"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="searchTotal"
              :page-count="count"
              :clstag="`newscenter|keycount|search-PC|click-changeCurrent`"
            >
            </el-pagination>
            <p @click="addCurrent">&gt;&gt;</p>
            <span
              >{{ $t('共') }}{{ searchTotal }} {{ $t('条结果') }} / {{ pageNum
              }}{{ $t('页') }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import '@/assets/css/search.css'
import { getNewSearch } from '@/api/news'
import { formatDate } from '@/utils/formatDate'
import Header from './components/headerBanner'
import { getLang } from '@/utils'
import Tab from './components/headerTab'
import getTranslation from '@/locale/getTranslation'
import Footer from './components/footer'
export default {
  components: {
    Header,
    Tab,
    Footer
  },
  data() {
    return {
      input: '',
      pageNum: 1,
      pageSize: 10,
      searchData: [],
      searchTotal: 0,
      count: 0,
      msg: '',
      lang: getLang()
    }
  },
  computed: {},
  watch: {
    input() {
      if (this.input == '') {
        this.searchData = ''
        this.searchTotal = 0
      }
    },
    '$route.query.search': {
      handler: function(val) {
        this.input = val
        this.getSearchData()
      },
      immediate: true
    }
  },
  methods: {
    onSearch(input) {
      this.input = input
      this.getSearchData()
    },
    //搜索json
    getSearchData() {
      getNewSearch({
        query: this.input,
        filter: `cateId:portal`,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.result && res.result.data) {
          this.searchData = res.result.data.resultdata
          this.searchTotal = res.result.data.resultcount
          this.count = res.result.data.pageCount
        } else {
          this.searchData = []
          this.searchTotal = 0
          this.count = 0
        }
      })
    },
    // filters: {
    //   formatDate(time) {
    //     let date = new Date(time)
    //     return formatDate(date, 'yyyy-MM-dd   hh:ss')
    //   }
    // },
    btnSearch() {
      if (this.input == '') {
        this.$message({
          message: getTranslation('搜索内容不能为空'),
          type: 'warning'
        })
      } else {
        this.getSearchData()
      }
    },
    changeCurrent(num) {
      this.pageNum = num
      this.getSearchData()
    },
    searchDetail(item) {
      let { cateId, page } = item
      if (cateId == 'portal') {
        window.location.href = '//www.ciftis.org' + page
      } else {
        this.$router.push({
          path: '/consult',
          query: {
            id: item.contentId ? item.contentId : item.page,
            type: 4
          }
        })
      }
    },
    subCurrent() {
      if (this.input != '') {
        this.pageNum = 1
        this.getSearchData()
      }
    },
    addCurrent() {
      if (this.input != '') {
        this.pageNum = Math.ceil(this.searchTotal / this.pageSize)
        this.getSearchData()
      }
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  beforeRouteLeave(to, from, next) {
    this.input = ''
    next()
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd   hh:ss')
    }
  }
}
</script>
<style scoped></style>
